import { GpsDeviceIdOption } from '../types'

export function findFirstEligibleGpsDeviceId(gpsDeviceIdOptions?: GpsDeviceIdOption[]) {
  if (!gpsDeviceIdOptions) return undefined

  const suggestedOption = gpsDeviceIdOptions.find(
    option => option.preset !== 'divider' && !option.disabled,
  )
  return suggestedOption?.preset !== 'divider' ? suggestedOption?.value : undefined
}
